import { render } from "./GdprPage.vue?vue&type=template&id=eb1511c0&scoped=true&ts=true"
import script from "./GdprPage.vue?vue&type=script&lang=ts"
export * from "./GdprPage.vue?vue&type=script&lang=ts"

import "./GdprPage.vue?vue&type=style&index=0&id=eb1511c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb1511c0"]])

export default __exports__